'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dFeatures$0024 from "./presto.types$-Features$.js";
var $p;
/** @constructor */
function $c_Lpresto_ListProxiesPage$() {
}
export { $c_Lpresto_ListProxiesPage$ as $c_Lpresto_ListProxiesPage$ };
$p = $c_Lpresto_ListProxiesPage$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_ListProxiesPage$;
/** @constructor */
function $h_Lpresto_ListProxiesPage$() {
}
export { $h_Lpresto_ListProxiesPage$ as $h_Lpresto_ListProxiesPage$ };
$h_Lpresto_ListProxiesPage$.prototype = $p;
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return (-1558337379);
});
$p.l = (function() {
  return "ListProxiesPage";
});
$p.r = (function() {
  return 0;
});
$p.s = (function() {
  return "ListProxiesPage";
});
$p.j = (function(n) {
  throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.dw = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Some($j_presto$002etypes$0024$002dFeatures$0024.$m_Lpresto_types$Features$().lH);
});
var $d_Lpresto_ListProxiesPage$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_ListProxiesPage$, "presto.ListProxiesPage$", ({
  LE: 1,
  a2: 1,
  b: 1,
  c: 1,
  a: 1,
  e: 1,
  g: 1,
  m: 1
}));
export { $d_Lpresto_ListProxiesPage$ as $d_Lpresto_ListProxiesPage$ };
var $n_Lpresto_ListProxiesPage$;
function $m_Lpresto_ListProxiesPage$() {
  if ((!$n_Lpresto_ListProxiesPage$)) {
    $n_Lpresto_ListProxiesPage$ = new $c_Lpresto_ListProxiesPage$();
  }
  return $n_Lpresto_ListProxiesPage$;
}
export { $m_Lpresto_ListProxiesPage$ as $m_Lpresto_ListProxiesPage$ };
//# sourceMappingURL=presto.-List-Proxies-Page$.js.map
